import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import CardLayout from '../../../components/Layout/CardLayout';
import ReactDataTable from '../../../components/ReactDataTable/ReactDataTable';
import useFetch from '../../../hooks/useFetch';
import request from '../../../request/request';
import EditButton from '../../../components/Button/EditButton';
import DeleteButton from '../../../components/Button/DeleteButton';
import DeleteModal from '../../../components/Modal/DeleteModal';

const TeamMembers = () => {
    const { result, isLoading, setRefresh } = useFetch(() => request.getAll('team-members'));
    const navigate = useNavigate();

    const [modalOpen, setModalOpen] = useState('');
    const [selectedItem, setSelectedItem] = useState('');

    console.log(result);

    const columns = [
        {
            name: 'Name',
            wrap: true,
            center: 'true',
            selector: (row) => row?.name,
        },
        {
            name: 'Title',
            wrap: true,

            center: 'true',
            selector: (row) => row?.title,
        },
        {
            name: 'Side Img',
            wrap: true,
            width: '150px',
            cell: (row) => (
                <img
                    style={{ width: '100%' }}
                    src={`${process.env.REACT_APP_UPLOAD_URL}/website/${row?.image}`}
                    alt='side Img'
                />
            ),
        },
        {
            name: 'Social Icons',
            cell: (row) => (
                <div>
                    {row?.social_icons?.map((item) => (
                        <ul key={item?.id}>
                            <li>{item?.title}</li>
                        </ul>
                    ))}
                </div>
            ),
        },
        {
            name: 'Status',
            center: 'true',
            selector: (row) => (row?.status === 1 ? 'Active' : 'InActive'),
        },
        {
            name: 'Action',
            center: 'true',
            cell: (row) => (
                <div>
                    <EditButton
                        onClick={() => navigate(`/dashboard/website/team-members/edit/${row?.id}`)}
                    />
                    <DeleteButton
                        onClick={() => {
                            setModalOpen('delete');
                            setSelectedItem(row);
                        }}
                    />
                </div>
            ),
        },
    ];

    // delete function

    const abotUsDeleteHandler = () =>
        request.delete('team-members', selectedItem?.id, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });

    return (
        <CardLayout
            title='Team Members List'
            buttonTitle='Add New Team Members'
            addButtonHandler={() => navigate('/dashboard/website/team-members/add')}
        >
            <ReactDataTable columns={columns} data={result} pending={isLoading} />

            {/* delete about us */}

            {modalOpen === 'delete' && (
                <DeleteModal
                    isOpen={modalOpen === 'delete'}
                    onClose={() => setModalOpen('')}
                    handleDelete={abotUsDeleteHandler}
                />
            )}
        </CardLayout>
    );
};

export default TeamMembers;
